import React, { ReactElement } from "react";

import {
  PdfExpandModal,
  ExpandedPdfFrame,
  PdfExpandModalBody,
  PdfExpandCloseButton,
} from "pages/management/warranty/styles";

interface Props {
  open: boolean;
  onClose: () => void;
  pdfUrl?: string;
  title: string;
}

function PdfPreviewModal({
  open,
  onClose,
  pdfUrl,
  title,
}: Props): ReactElement | null {
  if (!pdfUrl?.trim()) {
    return null;
  }

  return (
    <PdfExpandModal open={open} onClose={onClose}>
      <PdfExpandModalBody>
        <PdfExpandCloseButton
          type="button"
          onClick={onClose}
          aria-label="Close PDF preview"
        >
          ×
        </PdfExpandCloseButton>
        <ExpandedPdfFrame src={pdfUrl} title={title} />
      </PdfExpandModalBody>
    </PdfExpandModal>
  );
}

export default PdfPreviewModal;
